import { ConversationWidget } from "./components/ConversationWidget";
import "./components/LandingPage.css";
import "./components/ConversationWidget.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { Navigation } from "./components/Navigation";
import LandingPage from "./components/LandingPage";
import ManagerPage from "./components/ManagerPage";
import { ConversationWidgetDemo } from "./components/ConversationWidgetDemo";

function AppContent() {
  const location = useLocation();

  return (
    <div className="App">
      <Navigation />
      <Routes>
        <Route path="/" element={<Navigate to="/managers" replace />} />
        <Route
          path="/employees"
          element={<LandingPage onNavigate={() => {}} />}
        />
        <Route
          path="/managers"
          element={<ManagerPage onNavigate={() => {}} />}
        />
        <Route
          path="/features"
          element={
            <div className="features-container">
              <section id="features" className="features-section">
                {/* Features content from LandingPage */}
              </section>
            </div>
          }
        />
        <Route path="*" element={<Navigate to="/managers" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
